'use client';
import { capitalizeText } from '@cat-ecom/common/utils/commonUtils';
import { RegisterSignInButtonToast } from '../equipment-toast/register-signin-button-toast';
import { useQuickToast } from 'hooks/use-toast';
import { useTranslations } from 'next-intl';
import { useCallback, useEffect } from 'react';
import { getCookie } from 'utils/cookieUtils';
import { AddEquipmentToast } from '../constants';
import { removeCookie } from '@cat-ecom/common/utils/cookieUtils';
import {
  FORM_SAVE_EQUIPMENT,
  PCC_MY_EQUIPMENT_PAGE,
  STATUS_SUCCESS
} from 'constants/analyticsConstants';
import { useFormSubmitEvent } from 'hooks/analytics/use-form-submit-event';

const AddEquipmentSuccessToast = ({ isLoggedIn }: { isLoggedIn: boolean }) => {
  const toast = useQuickToast();
  const t = useTranslations();
  const selectedEquipment = getCookie(AddEquipmentToast);
  const { fireEvent } = useFormSubmitEvent();

  const fireFormSubmissionGAEvents = useCallback(
    (payload: AnalyticsEventPayload) => {
      fireEvent(payload);
    },
    [fireEvent]
  );

  useEffect(() => {
    if (selectedEquipment && selectedEquipment !== 'error') {
      const {
        model = '',
        equipmentFamily = '',
        serialNumber = ''
      }: {
        equipmentFamily?: string;
        model?: string;
        serialNumber?: string;
      } = JSON.parse(decodeURIComponent(selectedEquipment));
      const currentlyShoppingText = t('CURRENTLY_SHOPPING', {
        0: model,
        1: capitalizeText(equipmentFamily)
      });
      const contentGuestToast = !isLoggedIn ? (
        <RegisterSignInButtonToast
          signInText={t('SIGN_IN')}
          registerText={t('SL_REGISTER')}
          guestSaveText={t('GUEST_EQUIPMENT_SAVE')}
        />
      ) : null;

      const eventContent = {
        formName: FORM_SAVE_EQUIPMENT,
        formLocation: PCC_MY_EQUIPMENT_PAGE,
        formContent: serialNumber,
        formContent2: `${model} ${equipmentFamily}`
      };
      toast.success({
        message: currentlyShoppingText,
        content: contentGuestToast,
        delay: 5
      });
      fireFormSubmissionGAEvents({
        ...eventContent,
        formStatus: STATUS_SUCCESS
      });
      removeCookie(AddEquipmentToast);
    }
  }, [fireFormSubmissionGAEvents, isLoggedIn, selectedEquipment, t, toast]);
  return null;
};

export default AddEquipmentSuccessToast;
